exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bg-1 {\n  background-color: #3d3b8f6e;\n}\n.btn-plus {\n  border-radius: 5px;\n}\n", ""]);

// exports
